import { window as $window } from "global";

const CONSENT_COOKIE = "OptanonConsent";
const ALERTBOX_COOKIE = "OptanonAlertBoxClosed";

class OneTrust {
    base64EncodedHTML: string;
    constructor() {
        this.base64EncodedHTML = __ONETRUST_HTML__;
    }

    static async ready() {
        const oneTrust = new OneTrust();

        // check if ALERTBOX_COOKIE cookie is set
        const alertBoxValue = await oneTrust.getCookieValue(ALERTBOX_COOKIE);

        if (alertBoxValue) {
            // check if CONSENT_COOKIE cookie is set
            const consentValue = await oneTrust.getCookieValue(CONSENT_COOKIE);

            // if set, parse cookie and set global OnetrustActiveGroups
            const data = oneTrust.parseUrlEncodedString(consentValue);

            if (data.groups) {
                const activeGroups = [];
                activeGroups.push("");
                const groups = data.groups.split(",");
                for (let i = 0; i < groups.length; i++) {
                    const group = groups[i];
                    const parts = group.split(":");
                    if (parts[1] === "1") {
                        activeGroups.push(parts[0]);
                    }
                }
                activeGroups.push("");
                $window.OnetrustActiveGroups = activeGroups.join(",");
                $window.OptanonWrapper();
            }
        } else {
            // if not set, show banner

            // consent is opt-out
            $window.OnetrustActiveGroups = ",C0001,C0002,C0003,C0004,C0005,";
            $window.OptanonWrapper();

            oneTrust.appendBase64EncodedHTML();

            const elem = document.getElementById("onetrust-banner-sdk");

            const oneTrustPCBtn = document.getElementById(
                "onetrust-pc-btn-handler",
            );
            const oneTrustAcceptBtn = document.getElementById(
                "onetrust-accept-btn-handler",
            );

            if (oneTrustPCBtn) {
                oneTrustPCBtn.addEventListener("click", (event: MouseEvent) => {
                    event.preventDefault();
                    event.stopPropagation();

                    // search for the overlay filter and unhide it
                    const filters = document.querySelectorAll(
                        ".onetrust-pc-dark-filter",
                    );
                    for (let i = 0; i < filters.length; i++) {
                        const node = filters[i];
                        node.classList.remove("ot-hide");
                    }

                    const accordionButtons =
                        document.querySelectorAll<HTMLButtonElement>(
                            ".ot-accordion-layout > button",
                        );

                    for (let i = 0; i < accordionButtons.length; i++) {
                        const accordionBtn = accordionButtons[i];
                        //node.classList.remove("ot-hide");
                        accordionBtn.addEventListener(
                            "click",
                            (event: MouseEvent) => {
                                event.preventDefault();
                                event.stopPropagation();

                                const isExpanded =
                                    accordionBtn.getAttribute(
                                        "aria-expanded",
                                    ) === "true";
                                accordionBtn.setAttribute(
                                    "aria-expanded",
                                    `${!isExpanded}`,
                                );
                            },
                        );
                    }

                    // search for the modal and unhide it
                    const modal = document.getElementById("onetrust-pc-sdk");
                    if (!modal) {
                        return;
                    }
                    modal.classList.remove("ot-hide");
                    modal.style.setProperty("height", "620px");
                });
            }
            if (oneTrustAcceptBtn) {
                oneTrustAcceptBtn.addEventListener(
                    "click",
                    (event: MouseEvent) => {
                        event.preventDefault();
                        event.stopPropagation();

                        if (!elem) {
                            return;
                        }
                        elem.classList.add("hide");

                        oneTrust.writeConsentCookie(
                            "C0001:1,C0002:1,C0003:1,C0004:1,C0005:1",
                            "1",
                        );

                        oneTrust.writeAlertBoxCookie();

                        $window.OnetrustActiveGroups =
                            ",C0001,C0002,C0003,C0004,C0005,";
                        $window.OptanonWrapper();
                    },
                );
            }

            // search for the "Confirm My Choices" button and add click listener
            const buttons = document.querySelectorAll<HTMLButtonElement>(
                ".save-preference-btn-handler",
            );

            for (let i = 0; i < buttons.length; i++) {
                const node = buttons[i];
                node.addEventListener("click", (event: MouseEvent) => {
                    event.preventDefault();
                    event.stopPropagation();

                    let groups = [];
                    const activeGroups = [];
                    // strictly necessary cookies are always enabled
                    groups.push("C0001:1");
                    activeGroups.push("");
                    activeGroups.push("C0001");

                    // search for the "Confirm My Choices" button and add click listener
                    const switches =
                        document.querySelectorAll<HTMLInputElement>(
                            ".category-switch-handler",
                        );

                    for (let i = 0; i < switches.length; i++) {
                        const input = switches[i];
                        const optanongroupid = input.dataset.optanongroupid;

                        let group;
                        if (input.checked) {
                            group = `${optanongroupid}:1`;
                            activeGroups.push(optanongroupid);
                        } else {
                            group = `${optanongroupid}:0`;
                        }
                        if (group) {
                            groups.push(group);
                        }
                    }

                    oneTrust.writeConsentCookie(groups.join(","), "1");

                    oneTrust.writeAlertBoxCookie();

                    activeGroups.push("");
                    $window.OnetrustActiveGroups = activeGroups.join(",");
                    $window.OptanonWrapper();

                    // search for the modal and hide it
                    const modal = document.getElementById("onetrust-pc-sdk");
                    if (!modal) {
                        return;
                    }
                    modal.classList.add("ot-hide");

                    // search for the overlay filter and hide it
                    const filters = document.querySelectorAll(
                        ".onetrust-pc-dark-filter",
                    );
                    for (let i = 0; i < filters.length; i++) {
                        const node = filters[i];
                        node.classList.add("ot-hide");
                    }

                    if (!elem) {
                        return;
                    }
                    elem.classList.add("hide");
                });
            }

            if (elem) {
                setTimeout(() => {
                    elem.classList.add("slide-up");
                    elem.focus();
                }, 250);
            }
        }
    }

    async getCookieValue(cookieName: string) {
        if ("cookieStore" in $window) {
            try {
                const cookie = await $window.cookieStore.get(cookieName);
                if (cookie) {
                    return cookie.value;
                } else {
                    return null;
                }
            } catch (error) {
                return null;
            }
        } else {
            // Fallback to using document.cookie if needed
            return this.getCookieValueFallback(cookieName);
        }
    }

    getCookieValueFallback(cookieName: string) {
        // Fallback function using document.cookie
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent($window.document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    appendBase64EncodedHTML() {
        try {
            const decodedHTML = atob(this.base64EncodedHTML);

            const tempElement = $window.document.createElement("div");
            tempElement.innerHTML = decodedHTML;

            while (tempElement.firstChild) {
                $window.document.body.appendChild(tempElement.firstChild);
            }
        } catch (error) {
            console.error("Error decoding or appending HTML:", error);
        }
    }

    parseUrlEncodedString(queryString: string) {
        const params = new URLSearchParams(queryString);
        const result: Record<string, string> = {};
        for (const [key, value] of params.entries()) {
            result[key] = value;
        }
        return result;
    }

    writeAlertBoxCookie() {
        this.writeCookie(ALERTBOX_COOKIE, new Date().toISOString());
    }

    writeConsentCookie(groups: string, interactionCount = "0") {
        const params = new URLSearchParams();
        params.append("version", "202504.1.0");
        params.append("interactionCount", interactionCount);
        params.append("isAnonUser", "1");
        params.append("isGpcEnabled", "0");
        params.append("browserGpcFlag", "0");
        params.append("isIABGlobal", "false");
        params.append("hosts", "");
        params.append("landingPath", "NotLandingPage");
        params.append("groups", groups);
        params.append("intType", "1");
        params.append("geolocation", "US;NC");
        params.append("AwaitingReconsent", "false");

        this.writeCookie(CONSENT_COOKIE, params.toString());
    }

    writeCookie(name: string, value: string) {
        const expire = new Date();
        expire.setDate(expire.getDate() + 365); // Add 1 year

        const cookieValue = `${name}=${value}; expires=${expire.toUTCString()}; path=/; samesite=lax`;
        console.log(cookieValue);
        $window.document.cookie = cookieValue;
    }
}

export { OneTrust };
